import React, { Component } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import cx from 'classnames'
import premiumAccess from '../../images/premium3.png'

const CheckboxField = ({ field, label, handleSubmit, premium = true }) => (
  <div>
    <label>
      <input
        type='checkbox'
        value={field.value}
        {...field}
        disabled={!premium}
        onChange={event => {
          field.onChange(event)
          setTimeout(handleSubmit)
        }} />
      <span className='indicator'></span>
      {label}
      {
        (premium) ? null : (<img src={premiumAccess} className='premium notifications' alt='premiumAccess' width={18} height={18} />)
      }
    </label>
  </div>
)

export default class MobilePreferencesForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: true
    }
    this.toggleExpand = this.toggleExpand.bind(this)
  }

  toggleExpand() {
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    const {
      fields: { permanentIssues, unsatisfactory, needsWork, needsReview, emergencyServices, billable, unableToComplete, delayed, workOrderDelay, workTrackerMonthlyReports },
      error,
      submitting,
      handleSubmit
    } = this.props
    const {
      expanded = false
    } = this.state

    const isAdministrator = (this.props.userType === 'Administrator')
    const isAccountManager = (this.props.userType === 'AccountManager')
    const isSupervisor = (this.props.userType === 'Supervisor')
    const isTechnician = (this.props.userType === 'Technician')

    return (
      <form onSubmit={handleSubmit}>
        <div className="expandable">
          <h1>Email Notifications</h1>
          <img onClick={this.toggleExpand} className={cx('toggle-button', { '_up': expanded })} src={require('../../images/arrow-down.svg')} />
          {expanded &&
            <ReactCSSTransitionGroup
              component='div'
              transitionName='workOrderGroup'
              transitionEnterTimeout={250}
              transitionLeaveTimeout={250}
            >
              <div className='checkbox-group'>
                <div className='checkboxes-container'>
                  <CheckboxField field={permanentIssues} label='New Permanent Issue' handleSubmit={handleSubmit} />
                  {!isTechnician && <CheckboxField field={needsWork} label='New Attention Required Issue' handleSubmit={handleSubmit} />}
                  {!isTechnician && <CheckboxField field={needsReview} label='New Unresolved Issue' handleSubmit={handleSubmit} />}
                  <CheckboxField field={unsatisfactory} label='Area Marked as Corrective Action' handleSubmit={handleSubmit} premium={!isSupervisor} />
                  <CheckboxField field={emergencyServices} label='Emergency Services' handleSubmit={handleSubmit} premium={!isSupervisor} />
                  <CheckboxField field={billable} label='Billable Services' handleSubmit={handleSubmit} premium={!isSupervisor} />
                  <CheckboxField field={unableToComplete} label='Unable to Complete' handleSubmit={handleSubmit} premium={!isSupervisor} />
                  <CheckboxField field={delayed} label='Service Delay' handleSubmit={handleSubmit} premium={!isSupervisor} />
                  {(isAdministrator || isAccountManager) && <CheckboxField field={workOrderDelay} label='Work Order Delay' handleSubmit={handleSubmit} />}
                  <CheckboxField field={workTrackerMonthlyReports} label='Work Tracker Monthly Reports' handleSubmit={handleSubmit} premium={!isSupervisor} />
                </div>
              </div>
            </ReactCSSTransitionGroup>
          }
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/email-preferences-form.js